import styled from "styled-components";
import { deviceDF } from "utils/breakPoints";

const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.justify ? `${props.justify}` : "flex-end"};

  flex-wrap: wrap;
  @media ${deviceDF.tablet} {
    flex-direction: column;
  }
`;
const BarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  flex-wrap: wrap;
  @media ${deviceDF.tablet} {
    flex-direction: column;
  }
`;
const BarPercent = styled.span`
  font-weight: bold;
  position: absolute;
  color: #adadad;
  top: 50%;
  right: 50%;
  font-size: 12px;
  z-index: 100;
  line-height: 0.6rem;
  transform: translate(50%, -50%);
`;

const ImageGiotank = styled.img`
  width: 32px;
  height: auto;
`;

export {
  ColumnContainer,
  BarContainer,
  ImageGiotank,
  BarPercent,
};
